import { Info } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Demo, DsSection } from '../primitives'

const SIDES = ['top', 'right', 'bottom', 'left'] as const

export function TooltipSection() {
  return (
    <DsSection id="tooltip" title="Tooltip">
      <Demo label="On a labeled button" className="flex items-center gap-4">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline">Hover or focus me</Button>
          </TooltipTrigger>
          <TooltipContent>Saved automatically every 30 seconds</TooltipContent>
        </Tooltip>
      </Demo>

      <Demo
        label="On an icon-only trigger — still needs its own aria-label"
        className="flex items-center gap-4"
      >
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="iconOnly"
              size="icon-sm"
              aria-label="More information"
              className="text-muted-foreground hover:text-foreground size-5"
            >
              <Info className="size-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Icon-only triggers should still carry an aria-label.</TooltipContent>
        </Tooltip>
      </Demo>

      <Demo label="Sides" className="flex items-center gap-8">
        {SIDES.map((side) => (
          <Tooltip key={side}>
            <TooltipTrigger asChild>
              <Button variant="outline" size="sm" className="capitalize">
                {side}
              </Button>
            </TooltipTrigger>
            <TooltipContent side={side}>Positioned {side}</TooltipContent>
          </Tooltip>
        ))}
      </Demo>
    </DsSection>
  )
}
